import api from './axios';

// Get overview stats
export const getDashboardOverview = async () => {
  const response = await api.get('/dashboard/overview');
  return response.data;
};

// Get trends data
export const getDashboardTrends = async (days = 7) => {
  const response = await api.get('/dashboard/trends', { params: { days } });
  return response.data;
};

// Get category breakdown
export const getCategoryBreakdown = async () => {
  const response = await api.get('/dashboard/categories');
  return response.data;
};

// Get priority breakdown
export const getPriorityBreakdown = async () => {
  const response = await api.get('/dashboard/priorities');
  return response.data;
};

// Get agent workload
export const getAgentWorkload = async () => {
  const response = await api.get('/dashboard/workload');
  return response.data;
};

// Get performance metrics
export const getPerformanceMetrics = async () => {
  const response = await api.get('/dashboard/performance');
  return response.data;
};

// Get recent activity
export const getRecentActivity = async (limit = 10) => {
  const response = await api.get('/dashboard/activity', { params: { limit } });
  return response.data;
};
